/* eslint-disable i18next/no-literal-string */
import React, { useCallback } from "react";
import styles from "./form-check-box.module.scss";
import classnames from "classnames";
import { Field, FieldProps, useFormikContext } from "formik";
import { observer } from "mobx-react-lite";
import type { FormCheckBoxProps } from "@whatslly/types/UI-V2/FormElements/FormCheckBoxType";
import { CheckBox } from "../../BaseElements/CheckBox";
import globalStyles from "../../../v2/globalStyles";
import { FormFieldV2 } from "../FormField";

export const FormCheckBox: React.FC<FormCheckBoxProps> = observer(
  ({ checked, required, marginBottom, marginTop, className, onChange, name, padding, paddingInline, ...props }) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks, @typescript-eslint/no-explicit-any
    const formikContext = useFormikContext<Record<string, any>>();
    const formOnChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        const newState = checked === undefined ? !formikContext.values[name] : !checked;
        formikContext.setFieldValue(name, newState, true);
        if (onChange) {
          return onChange(e);
        }
      },
      [checked, formikContext, name, onChange]
    );

    return (
      <FormFieldV2
        className={classnames(
          globalStyles[`mb-${marginBottom ?? "default"}`],
          globalStyles[`mt-${marginTop}`],
          globalStyles[`p-${padding}`],
          globalStyles[`pi-${paddingInline ?? "default"}`]
        )}
        errorText={formikContext.errors[name] as string}
        showError={!!formikContext.errors[name] && !!formikContext.touched[name]}
      >
        <Field
          type={props.type}
          placeholder={props.placeholder}
          touched={true}
          onChange={formOnChange}
          children={(fieldData: FieldProps) => {
            return (
              <CheckBox
                required={required}
                onChange={formOnChange}
                {...props}
                paddingInline={"none"}
                checked={checked ?? fieldData.field.value[name]}
                name={name}
              />
            );
          }}
          className={classnames(styles.FormtextInput, className)}
          {...props}
        />
      </FormFieldV2>
    );
  }
);
